import {groupBy, withPayloadType} from '@lib/utils';
import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import eachDayOfInterval from 'date-fns/eachDayOfInterval';
import endOfISOWeek from 'date-fns/endOfISOWeek';
import startOfISOWeek from 'date-fns/startOfISOWeek';
import addWeeks from 'date-fns/addWeeks';
import getISOWeek from 'date-fns/getISOWeek';
import {AppThunkApiConfig} from '../../createStore';
import {CalendarWeek, CalendarDay} from './types';
import {toCalendarWeeks, toCalendarDays} from './mappers';
import parseISO from 'date-fns/parseISO';

export const setToday = createAction('calendar/todaySet', withPayloadType<string>());

export const loadCalendarDays = createAsyncThunk<
  {weeks: CalendarWeek[]; days: CalendarDay[]},
  string,
  AppThunkApiConfig
>('calendar/loadCalendarDays', (today, {dispatch}) => {
  dispatch(setToday(today));

  const startOfCalendar = startOfISOWeek(parseISO(today));
  const endOfCalendar = endOfISOWeek(addWeeks(startOfCalendar, 3));
  const allDates = eachDayOfInterval({
    start: startOfCalendar,
    end: endOfCalendar,
  });

  const groups = groupBy(allDates, getISOWeek);
  const weeks = toCalendarWeeks(groups);
  const days = toCalendarDays(allDates);
  return {weeks, days};
});
